/**
 * @ngdoc directive
 * @name Breadcrumbs
 *
 * @description
   Adds breadcrumbs (*surprise*). Gets collapsed when 3 or more parents
 *
 * @scope
 * @param {Array} parents - array of objects with opened breadcrumb parents, every object should have 'name' property
 * @param {Function} open - callback on parent click
 * @param {String} openedGroupName - name of the opened breadcrumb
 * @param {String} icon - optional class of the icon, that will be visible when breadcrumbs are collapsed (when 3 or more parents)
 *
 * @example
    <breadcrumbs
      opened-group-name="'I am opened'"
      parents="[{ name: 'First Parent' }, { name: 'Second Parent' }]"
      open="alert"
      icon="icon-folder">
    </breadcrumbs>
 */

(function() {
  'use strict';

  breadcrumbs.$inject = ["PATH"];
  app.directive('breadcrumbs', breadcrumbs);

  function breadcrumbs(PATH) {
    var directive = {
      scope: {
        parents: '=',
        open: '=',
        openedGroupName: '=',
        icon: '@?',  // icon class if any,
        hideParent: '=?'
      },
      restrict: 'E',
      templateUrl: PATH.components + 'breadcrumbs/breadcrumbs.tpl.html'
    };

    return directive;
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/breadcrumbs/breadcrumbs.js